import { useStore } from 'effector-react'
import { $section, getSection, sectionMounted } from './model'
import { useLayoutEffect } from 'react'

export const useEditBudgetItem = () => {
  const section = useStore($section)
  const loading = useStore(getSection.pending)

  useLayoutEffect(() => {
    sectionMounted()
  }, [])

  return { section, loading }
}
